// extracted by mini-css-extract-plugin
module.exports = {"checkout-item":"prescriptionCheckoutItem_checkout-item__POysX","image":"prescriptionCheckoutItem_image__kAxly","price":"prescriptionCheckoutItem_price__1LqK0"};